import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import DropDownComponent from "../../../../../lib/html5-software-library/src/ranj/components/dropdown/DropDownComponent";
import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import { getURLParameter } from "../../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import SoundType from "../../sound/SoundType";
import AbstractMediator from "../../ui/AbstractMediator";
import OverlayFactory from "../../ui/OverlayFactory";
import LanguageEvent from "../model/LanguageEvent";
import LanguageModel from "../model/LanguageModel";

export default class LanguageSelectScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {OverlayFactory} overlayFactory 
     * @param {LanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     * @param {LanguageModel} languageModel 
     */
    constructor(target, dispatcher, layoutManager, overlayFactory, languagePack, soundManager, languageModel) {
        super(target, dispatcher, layoutManager, overlayFactory);

        this._languagePack = languagePack;
        this._soundManager = soundManager;
        this._languageModel = languageModel;
    }

    initialize() {
        super.initialize();

        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), null, SoundType.SOUND_CLICK)

        // Hides dropdown item - it is generated by the DropDownComponent
        this._target.languageDropdown.item.visible = false;

        this._languageDropdown = new DropDownComponent(this._target.languageDropdown, lib.LanguageSelectAssets.DropdownItem, this._languageModel.availableLanguages);

        this._handleLanguageSelectedBound = this._handleLanguageSelected.bind(this);
        this._languageDropdown.addEventListener('change', this._handleLanguageSelectedBound);

        const defaultLanguageFromAvailableLanguages = this._languageModel.availableLanguages.find(l => l.id === this._languageModel.defaultLanguage);
        this._languageDropdown.selectItem(defaultLanguageFromAvailableLanguages);
    }

    destroy() {
        super.destroy();

        this._languageDropdown.removeEventListener('change', this._handleLanguageSelectedBound);
        this._languageDropdown.destroy();
    }

    _handleLanguageSelected(evt) {
        /** @type {DropDownComponent} */
        const dropdown = evt.target;
        this._selectedLanguageCode = dropdown.selectedItem ? dropdown.selectedItem.id : null;
        this._continueButton.setEnabled(!!this._selectedLanguageCode);
    }

    _handleContinueButton() {
        if (this._languageSelected || !this._selectedLanguageCode) {
            return;
        }
        this._languageSelected = true; // Ignore any button presses in the future

        const selectLanguageEventData = {
            languageCode: this._selectedLanguageCode,
        };
        this.dispatch(LanguageEvent.SELECT, { data: selectLanguageEventData });

        this.closeScreen(this._target, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }
}